import { createFileRoute, redirect } from '@tanstack/react-router';

/** Compat: URL antiga → /admin/estabelecimentos */
export const Route = createFileRoute('/_authenticated/estabelecimentos/')({
  beforeLoad: () => redirect({ to: '/admin/estabelecimentos' }),
});
